
import { Component, Vue, Emit, Watch, Prop } from "vue-property-decorator";
import LoadingAnimation from "@/components/loading/LoadingAnimation.vue";
import { fetchLineRegister } from "@/services/userService";
import BoxError from "@/components/box/BoxError/BoxError.vue";
import store from "@/store";
const Words: Dictionary = {
  error: "法人会員IDまたは法人会員パスワードに誤りがあります。",
  account: "法人会員ID",
  password: "法人会員パスワード",
  login: "次へ",
};
const systemErrorObj = {
  title: "システムエラー",
  message: "サーバーからの応答が無いため処理を実行できませんでした。<br />お手数ですが、しばらく時間が経った後に、再度お試しをお願いします。",
  button: "top"
}

@Component({
  components: {
    LoadingAnimation,
    BoxError,
  },
})
export default class FormAlignmentLineLoggedIn extends Vue {
  private words = Words;
  // private username = null;
  // private password = null;
  private agree: boolean = false;
  private error: string | null = null;
  // private meta = this.$route.meta;
  private loading: boolean = false;
  private showLoading: boolean = false;
  private loadingTimerId: number | null = null;

  private boxError: {title: string; message: string; button: string | null;} | null = null;

  @Prop({ type: String, default: "" })
  readonly lineAccessToken!: string;
  // private redirectPayload: { access_token: string; id_token: string } | null =
  //   null;

  get lang(): string {
    return store.getters["auth/lang"];
  }

  get token(): string {
    return store.getters["auth/token"];
  }

  @Watch("loading")
  private onChagedLoading(newState: boolean) {
    if (this.loadingTimerId) {
      clearTimeout(this.loadingTimerId);
      this.loadingTimerId = null;
    }
    if (newState) {
      this.loadingTimerId = window.setTimeout(() => {
        this.showLoading = true;
        this.loadingTimerId = null;
      }, 3000);
    } else {
      this.showLoading = false;
    }
  }


  private handleSkip() {
    this.$emit("skipLeaveConfirm");
    let { redirect } = this.$route.query;
    if (redirect && typeof redirect !== "string") {
      redirect = redirect[0] || "/";
    }

    this.$router.push({
      path: (redirect as string) || "/",
    });
  }

  @Emit()
  private async onSubmit() {
    this.error = null;

    // if (!this.username || !this.password) {
    //   console.warn("法人会員IDまたは法人会員パスワードに誤りがあります。");
    //   this.error = "法人会員IDまたは法人会員パスワードに誤りがあります。";
    //   return;
    // }

    if (!this.agree) {
      console.warn("利用規約への同意をお願いします");
      this.error = "利用規約への同意をお願いします";
      return;
    }

    try {
      this.loading = true;

      await fetchLineRegister(this.lineAccessToken)
        .then(async (data)=>{
          await store.dispatch("auth/updateUser")
          this.$emit("updateViewState", 2.5);
        })
        .catch((e)=>{
          if (e.status === 406) {
            this.boxError = {
              title: "LINEアカウントでのログインが出来ません",
              message: "ご指定の法人会員IDでは本機能での<br class='pc'>ログインをご利用いただけません。",
              button: "top"
            }
          } else {
            this.boxError = systemErrorObj;
          }
        })

    } catch (e: any) {
      console.error("catch", e);
      this.error = e.message;
    } finally {
      this.loading = false;
    }
  }

  // created() {
  //   if (store.state.temp.redirectPayload) {
  //     this.redirectPayload = store.state.temp.redirectPayload;
  //   } else {
  //     this.$router.push({
  //       name: "error",
  //       query: {
  //         status: "500",
  //       },
  //     });
  //   }
  // }
  
}
